/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Invite_Errors_Not_AuthorizedInputs */

const nl_invite_errors_not_authorized = /** @type {(inputs: Invite_Errors_Not_AuthorizedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Je bent niet gemachtigd om deze uitnodiging te accepteren.`)
};

/**

* @param {Invite_Errors_Not_AuthorizedInputs} inputs
* @param {{ locale?: "nl" }} options
* @returns {LocalizedString}
*/
const invite_errors_not_authorized = /** @type {((inputs?: Invite_Errors_Not_AuthorizedInputs, options?: { locale?: "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Invite_Errors_Not_AuthorizedInputs, { locale?: "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return nl_invite_errors_not_authorized(inputs)
});
export { invite_errors_not_authorized as "invite.errors.not_authorized" }